/**
 * Database constants shared between main app and service worker
 */

export const DB_CONFIG = {
  NAME: 'aurora-notifications',
  VERSION: 2,
  STORES: {
    LAST_LOCATION_NOTIFICATION: 'lastLocationNotification',
    USER_LOCATION: 'userLocation',
  }
} as const;